import { useState } from 'react'

import { Hint } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import esignaturePlacement1 from 'modules/documents/components/EsignaturePlacementFile/OnboardingModal/assets/01.svg'
import esignaturePlacement2 from 'modules/documents/components/EsignaturePlacementFile/OnboardingModal/assets/02.svg'
import esignaturePlacement3 from 'modules/documents/components/EsignaturePlacementFile/OnboardingModal/assets/03.svg'

interface Props {
  onClose: () => void
  onFinish: () => void
}

const OnboardingModal = ({ onClose, onFinish }: Props) => {
  const [_step, setStep] = useState<string>('1')

  const onboardingSteps = [
    {
      src: esignaturePlacement1,
      title: i18n.t('documents.beta.esignature_placement.onboarding.step_1.title'),
      description: i18n.t('documents.beta.esignature_placement.onboarding.step_1.description'),
    },
    {
      src: esignaturePlacement2,
      title: i18n.t('documents.beta.esignature_placement.onboarding.step_2.title'),
      description: i18n.t('documents.beta.esignature_placement.onboarding.step_2.description'),
    },
    {
      src: esignaturePlacement3,
      title: i18n.t('documents.beta.esignature_placement.onboarding.step_3.title'),
      description: i18n.t('documents.beta.esignature_placement.onboarding.step_3.description'),
    },
  ]

  const onChangeStep = (newStep: string) => {
    setStep(newStep)
  }

  return (
    <Hint.NewModal onClose={onClose} onFinish={onFinish} onChange={onChangeStep}>
      {onboardingSteps.map((step, index) => (
        <div key={index}>
          <Hint.NewModal.ImageStep
            src={step.src}
            title={step.title}
            description={step.description}
          />
        </div>
      ))}
    </Hint.NewModal>
  )
}

export default OnboardingModal
